import axios from 'axios'

const LoginTokenApi = (userAuthTokenInfo, loadLoginPage) => {
  return axios
    .post(
      `${process.env.GATSBY_API_ENDPOINT}/login/ValidateUserAuthToken`,
      userAuthTokenInfo
    )
    .then(response => {
      const result = response.data

      if (
        response !== null &&
        result.Result !== null &&
        result.Result.IsValidAuthToken === true
      ) {
        document.location = process.env.GATSBY_LOGIN_URL
      } else {
        loadLoginPage()
      }
    })
    .catch(error => {
      console.error(error)
      loadLoginPage()
    })
}

export default LoginTokenApi